export const priceFormat = (amount) => {
    const end = amount.toString().slice(amount.toString().length - 3, amount.toString().length);
    const carry = amount.toString().slice(0, amount.toString().length - 3);
    if (carry.length < 3) {
        return `${carry} ${end}`;
    }

    return `${priceFormat(carry)} ${end}`;
};